import React, { useState } from "react";
import EditButton from "assets/icons/EditButton.svg";

const ProfileSectionCard = ({
  title,
  children,
  showEditButton = false,
  onBeforeEdit,
  onSave,
  onCancel
}) => {

  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving]   = useState(false);

  // if got pending review, cannot open edit mode.
  const handleEditClick = () => {
    if (onBeforeEdit && onBeforeEdit() === false) {
      return;
    }
    setIsEditing(true);
  };

  const handleSaveClick = async() => {
    if (!onSave) return;

    setIsSaving(true);
    try {
      await onSave();
      setIsEditing(false);
    } catch (error) {
      console.error("Save failed", error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancelClick = () => {
    if (onCancel) onCancel();
    setIsEditing(false);
  };

  return (
    <div className="card border-0 shadow-sm profile-section-card">
      <div className="card-body p-0">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0 fw-bold profile-section-title">{title}</h4>
          <div>
            {!isEditing && showEditButton && (
              <button 
                type="button" 
                onClick={handleEditClick}
                className="btn btn-sm d-flex edit-btn" 
              >
                <img src={EditButton} alt="edit"/>
              </button>
            )}

            {isEditing && (
              <div className="btn-wrapper">
                <button
                  type="button"
                  className="px-3 cancel-btn"
                  onClick={handleCancelClick}
                  disabled={isSaving}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="px-3 save-changes-btn"
                  onClick={handleSaveClick}
                  disabled={isSaving}
                >
                  {isSaving ? "Saving..." : "Save Changes"}
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="section-content">
          {typeof children === 'function' ? children({ isEditing }) : children}
        </div>
      </div>
    </div>
  );
};

export default ProfileSectionCard;